import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

/**
 * Custom hook to set billToShipToPartnerRole in localStorage on mount.
 * @param {string} billToShipToPartnerRole - The partner role value to store.
 */
export function useBillToShipToPartnerRoleEffect(billToShipToPartnerRole) {
    useEffectWithErrorLogging(() => {
        localStorage.setItem('billToShipToPartnerRole', billToShipToPartnerRole);
    }, []);
}
